import UidGatewayApiClient from '../libs/uid-gateway-api-client';
import Platform            from '../platform';

export default {
  namespaced: true,
  state     : () => ({
    istyleId   : null,
    encryptedId: null,
    profileId  : null,
    visitorId  : null,
    isPremium  : null,
    bid        : null,
    isGuest    : null,
  }),
  getters: {
    ready: (state) => !!(state.istyleId || state.bid || state.isGuest),
  },
  mutations: {
    setSession(state, session) {
      state.istyleId    = session.istyleId;
      state.encryptedId = session.encryptedId;
      state.profileId   = session.profileId;
      state.visitorId   = session.visitorId;
      state.isPremium   = session.isPremium;
      state.bid         = session.bid;
      state.isGuest     = session.isGuest;
    },
  },
  actions: {
    initialize({ dispatch, rootState }) {
      if (rootState.context.platform === Platform.ATCOSME) {
        return dispatch('loadAtcosmeViewer');
      } else if (rootState.context.platform === Platform.BEAUTY_BOARD) {
        return dispatch('loadBeautyBoardViewer');
      } else if (rootState.context.platform === Platform.INTERNAL_SYSTEM) {
        return;
      }
      return Promise.reject(new Error('Invalid platform'));
    },
    loadAtcosmeViewer({ state, commit }) {
      return new UidGatewayApiClient(this.$axios || this._vm.$axios, this._vm.$fetch).getSession().then((session) => {
        commit('setSession', {
          istyleId   : session.id,
          encryptedId: session.encryptedId,
          profileId  : session.profileId,
          visitorId  : session.visitorId,
          isPremium  : session.isPremium,
          isGuest    : !session.id,
        });
      });
    },
    loadBeautyBoardViewer({ state, commit }) {
      return Promise.resolve();
    },
  },
};
